'use client';

import { Card } from '@app/app/_components/Card/Card';
import { LoginWidget } from '@app/app/_widgets/Login/LoginWidget';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

interface Props {
    swedbankLogoSrc: string;
    sebLogoSrc: string;
    luminorLogoSrc: string;
}

export function LoginSection({ swedbankLogoSrc, sebLogoSrc, luminorLogoSrc }: Props) {
    const router = useRouter();

    const handleSuccess = useCallback(() => {
        router.replace('/self-service');
    }, [router]);

    return (
        <Card className="gap-8 p-8 md:max-w-dialog">
            <LoginWidget
                onSuccess={handleSuccess}
                swedbankLogoSrc={swedbankLogoSrc}
                sebLogoSrc={sebLogoSrc}
                luminorLogoSrc={luminorLogoSrc}
                disableAutoFill
                disablePasting
            />
        </Card>
    );
}
